<template>
  <div class="bg-white">
    <loading :status="loading" />
    <template>
      <div class="space-x-2 flex justify-between">
        <h2 class="w-full font-bold tracking-wider uppercase">
          <span class="text-xl">{{ app.name }}</span>
          <small>
            <p v-if="app.phone">{{ app.phone }}</p>
            <p v-html="app.address"></p>
          </small>
        </h2>
      </div>
      <div class="border-b border-dotted border-black w-full p-1"></div>
      <div class="flex items-center mt-2">
        <label class="min-w-32 block font-bold uppercase">{{ $t('Generated at') }}</label>
        <span class="mr-4 inline-block">:</span>
        <div>{{ cashbook.created_at }}</div>
      </div>
      <div class="w-full col-span-3">
        <div class="flex justify-between py-1">
          <label class="min-w-32 block text-xl font-semibold uppercase">{{ $t('Detailed Summery') }}</label>
          <div class="text-xl">{{ cashbook.period | uppercase }}</div>
        </div>
        <div class="bg-green-50">
          <div class="flex justify-between py-1">
            <label class="min-w-32 block font-semibold uppercase">[+] {{ $t('Total sale amount') }}</label>
            <div>{{ cashbook.total_sale_amount | currency }}</div>
          </div>
          <div class="flex justify-between py-1">
            <label class="min-w-32 block font-semibold uppercase">[+] {{ $t('Total repair amount') }}</label>
            <div>{{ cashbook.total_repair_amount | currency }}</div>
          </div>
          <div  class="flex justify-between py-1">
            <label class="min-w-32 block font-semibold uppercase">[+] {{ $t('Total repair due recovery') }}</label>
            <div>{{ cashbook.total_due_recovery | currency }}</div>
          </div>
           <div class="flex justify-between py-1">
            <label class="min-w-32 block font-semibold uppercase">[=] {{ $t('Total sum up') }}</label>
            <div>{{ (cashbook.total_repair_amount + cashbook.total_sale_amount + cashbook.total_due_recovery) | currency }}</div>
          </div>
        </div>
        <div class="mt-2 bg-red-50">
          <div class="flex justify-between py-1">
            <label class="min-w-32 block font-semibold uppercase">[-] {{ $t('Total bill amount') }}</label>
            <div>{{ cashbook.total_bill_amount | currency }}</div>
          </div>
          <div class="flex justify-between py-1">
            <label class="min-w-32 block font-semibold uppercase">[-] {{ $t('Total refund amount') }}</label>
            <div>{{ cashbook.total_refund_amount | currency }}</div>
          </div>
          <div class="flex justify-between py-1">
            <label class="min-w-32 block font-semibold uppercase">[-] {{ $t('Total purchase price') }}</label>
            <div>{{ cashbook.total_custom_purchase_amount | currency }}</div>
          </div>
          <div class="flex justify-between py-1">
            <label class="min-w-32 block font-semibold uppercase">[-] {{ $t('Total expenses amount') }}</label>
            <div>{{ cashbook.expense_amount | currency }}</div>
          </div>
        </div>
        <div class="col-span-3 my-2">
          <div class="bg-gray-50">
            <div class="flex justify-between py-1">
              <label class="min-w-32 block font-semibold uppercase">{{ $t('Paid via cash') }}</label>
              <div>{{ cashbook.cash_in_till | currency }}</div>
            </div>
            <div class="flex justify-between py-1">
              <label class="min-w-32 block font-semibold uppercase">{{ $t('Paid via card') }}</label>
              <div>{{ cashbook.cash_in_card | currency }}</div>
            </div>
          </div>
        </div>
        <div class="flex justify-between py-1">
          <label class="min-w-32 block font-semibold uppercase">
            {{ $t('Grand amount') }} <small class="text-xs">[{{ $t('Cash in') }} + {{ $t('Incomings') }} - {{ $t('Outgoings') }}]</small>
          </label>
          <div>{{ cashbook.total_cash_out | currency }}</div>
        </div>
      </div>
      <div class="border-b border-dotted border-black w-full"></div>
      <div class="pt-2">
        <template v-if="app.terms.bills">
          <div class="font-bold text-left">
            {{ $t('I acknowledge the following terms and conditions') }}
          </div>
        </template>
        <div class="flex justify-between">
          <div class="font-bold flex-1">
            {{ $t('Signature') }}
          </div>
          <div class="font-sm">------------------------------</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'custom-bill',
  metaInfo() {
    return {
      title: this.$i18n.t('Print bill order'),
    };
  },
  computed: {
    app() {
      return this.$store.getters['app/getSettings'];
    },
  },
  data() {
    return {
      loading: false,
      cashbook: {
        total_cash_in: 0,
        total_sale_amount: 0,
        total_repair_amount: 0,
        total_bill_amount: 0,
        total_refund_amount: 0,
        total_custom_purchase_amount: 0,
        total_cash_out: 0,
        cash_in_till: 0,
        cash_in_card: 0,
      },
    };
  },
  mounted() {
    this.getCashbook();
  },
  methods: {
    getCashbook() {
      this.loading = true;
      axios
        .get(route('report-card-cashbook', this.$route.query))
        .then((response) => {
          this.cashbook = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
